module.exports = __webpack_public_path__ + "media/images/offers/code-d200fa38915b95ded6f8f5db1086a3c7.svg";